<template>
  <div>
     <div id="qrcode" ref="qrCodeUrl" style="display:none"></div>
     <!-- 展示图片格式 -->
     <div style="text-align:center">
        <img :src="qrcodeimg" alt="" width="200" height="200" v-show="qrcodeimg">
    </div>
  </div>
 

  


</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  props: ['url'],
  data() {
    return {
      qrcodeimg: '',
    }
  },
  methods: {
    //  生成二维码
    qrcode() {
      let qrcode = new QRCode('qrcode', {
        width: 200,
        height: 200, // 高度
        class: 'test',
        text: this.url, // 二维码内容
        correctLevel: QRCode.CorrectLevel.H,
        render: 'table', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      })

      let qrcodeEle = document.getElementById("qrcode")
      let cvs = qrcodeEle.querySelector('canvas')
      this.qrcodeimg = cvs.toDataURL('image/png')
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.qrcode()
    })
  },
  components: {
    QRCode,
  },
}
</script>

<style lang="scss" scoped></style>
